import React from "react";

class WinScreen extends React.Component {
  render() {
    return <div>You win! Humanity lives on!</div>;
  }
}

export default WinScreen;
